// All store content lives here: edit once, updates everywhere.
export const BUSINESS = {
  name: 'iPOINT',
  tagline: 'Where connectivity meets luxury',
  email: 'ipoint.ofcl@gmail.com',
  phone: '+91 97432 71010',
  phone2: '+91 87229 41494',
  whatsapp: '919743271010',
  instagram: 'ipoint_official',
  address: 'Shop No 2, Malaz Tower, Jalalbagh, Derlakatte, Mangalore, Karnataka, India',
}

// Delivery rules: edit fees, free-delivery thresholds and timelines.
export const DELIVERY = {
  localPrefixes: ['575'], // Mangalore pincodes start with 575
  local: { label: 'Mangalore & nearby', fee: 49, freeAbove: 999, eta: 'Same day or next day' },
  india: { label: 'Rest of India', fee: 99, freeAbove: 1999, eta: '3 to 5 working days' },
}

export const REPAIRS = [
  'Screen & display damage', 'Battery replacement', 'Charging problems', 'Camera problems',
  'Back glass damage', 'IC Issues',
  'Water/liquid damage', 'Software problems', 'Other phone issues',
]

export const REPAIR_INFO = {
  title: 'Apple & Android Phone Repair with Doorstep Pickup & Delivery',
  tagline: "Phone Broken? Don't Come to Us. We'll Come to You.",
}

// Shop by device: brand -> models. Keep this list current with the phones you stock.
export const DEVICES = {
  
}

// Offers, categories, reviews and products now come from the admin panel.
// These empty lists are kept only so any older `import { PRODUCTS } from '../data/site'` still builds.
// Once nothing imports them, you can delete these four lines.
export const OFFERS = []
export const CATEGORIES = []
export const REVIEWS = []
export const PRODUCTS = []